export default "__VITE_ASSET__147f93ad__"